import { createFileRoute, redirect } from '@tanstack/react-router';
import { DppSupplyChainTab } from '@/app/(client)/my-styles/-components/DppSupplyChainTab';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain',
)({
  beforeLoad: async ({ params }) => {
    const perms = await ensurePermissions();
    if (
      !perms['digital-products-passport'].canRead ||
      !perms['supply-chain-mapping'].canRead
    ) {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: { kind: params.kind, id: params.id },
      });
    }
  },
  component: DppSupplyChainRoute,
});

function DppSupplyChainRoute() {
  const { kind, id } = Route.useParams();
  if (!isEntityKindPath(kind)) return null;
  return <DppSupplyChainTab kind={kind} id={id} />;
}
